import { RefObject, useEffect } from 'react';

export function useScrollIntoViewActiveChange<
  TElement extends HTMLElement | null = HTMLElement,
  TDependency = void
>(ref: RefObject<TElement | null>, dependencyData?: TDependency) {
  useEffect(() => {
    if (ref.current) {
      ref.current.scrollIntoView({
        behavior: 'smooth',
        block: 'nearest',
        inline: 'nearest'
      });
    }
  }, [ref, dependencyData]);

  return ref;
}
